// Project Setting
export default {
    // document
    Title: "默认标题",
    Keywords: "默认关键词",
    Description: "默认描述",
};
